/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MessageType {
  human = 'human',
  ai = 'ai',
  plan_comparison = 'plan_comparison',
  deep_dive = 'deep_dive',
}
